import React, { Component } from 'react'
import {connect} from 'react-redux';

import {auth} from "../../actions";

import Products from './Products'
import SignUp from './SignUp'
import KlarnaCheckout from './KlarnaCheckout'

import logoImg from './logo.png'
import roseImg from './rose.jpg'
import whiteImg from './white.jpg'
import oakImg from './oak.jpg'

import './landing.css'

class Landing extends Component{
  constructor() {
    super();
    this.state = {
      signUpStatus: false,
      premiumSelected: true,
    }

    this.toggleSelected = this.toggleSelected.bind(this)
    this.hideSignUp = this.hideSignUp.bind(this)
  }

  componentDidMount() {
    if (this.props.isAuthenticated) {
      this.props.logout()
    }
  }

  hideSignUp() {
    this.setState({signUpStatus: true})
  }

  toggleSelected() {
    this.setState(state => ({premiumSelected: !state.premiumSelected}))
  }

  render() {
    return(
      <div className="Landing-container">
        <div className="Landing-header">
          <img
            src={logoImg}
            alt="Escapat logga"
            className="w-max-100"
          />
          <h1>Vinabonnemang</h1>
        </div>
        <div className="Landing-grid">
          <div className="row reverse">
            <div className="block">
              <div>
                <h3>Alltid fraktfritt</h3>
                <p>
                  Från gården Escapat direkt hem till dörren helt fraktfritt!
                </p>
              </div>
            </div>
            <div
              className="block"
              style={{backgroundImage: `url(${roseImg})`}} >
            </div>
          </div>
          <div className="row">
            <div
              className="block"
              style={{backgroundImage: `url(${whiteImg})`}} >
            </div>
            <div className="block">
              <div>
                <h3>Skräddarsy som du vill</h3>
                <p>
                  Välj fritt bland lådor och vilka månader om året du vill ha leverans.
                  Efter du har beställt kommer du få ett email med inloggningsuppgifter till din abonnemangssida.
                </p>
              </div>
            </div>
          </div>
          <div className="row reverse">
            <div className="block">
              <div>
                <h3>Ingen bindningstid</h3>
                <p>
                  Vi har ingen bindningstid, du kan avsluta när du vill.
                </p>
              </div>
            </div>
            <div
              className="block"
              style={{backgroundImage: `url(${oakImg})`}} >
            </div>
          </div>
        </div>
        <Products
          showSignUp={this.showSignUp}
          toggleSelected={this.toggleSelected}
          premiumSelected={this.state.premiumSelected}
          />
        {
          this.props.isAuthenticated
          ?
          <KlarnaCheckout token={this.props.token} />
          :
          <SignUp
            handleSubmit={this.handleSubmit}
            landingCreateUser={this.props.landingCreateUser}
            premiumSelected={this.state.premiumSelected}
            hideSignUp={this.hideSignUp}
            />
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    landingCreateUser: (email, premiumSelected) => {
      return dispatch(auth.landingCreateUser(email, premiumSelected))
    },
    logout: ( ) => {
      return dispatch(auth.logout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/containers/landing/Landing.jsx